import Vue from 'vue'
import Complex from '../models/complex'
import ApiBase from '@/api/apiBase'


class ApiComplexes {

  static all(callBack, errorCallBack){
    ApiBase.get(`/sport_places`,callBack,ApiComplexes.parseAll,errorCallBack)
  }
  static parseAll(response){
    var result = []
    for(var i in response.data.data){
      result.push(Complex.parse(response.data.data[i]))
    }
    return result
  }

  static find(complexID,callBack, errorCallBack){
    ApiBase.get(`/sport_places/${complexID}`,callBack,ApiComplexes.parseFind,errorCallBack)
  }
  static parseFind(response){
    return Complex.parse(response.data.data)
  }

  static create(complex,callBack,errorCallBack){
    let data = {
      "city": complex.city,
      "country": complex.country,
      "state": complex.state,
      "status": complex.status,
        "name": complex.name,
        "address": complex.address,
        "description": complex.description,
        "lat": complex.lat,
        "lng": complex.lng,
        "invoice": complex.invoice,
        "owner": {
          "email":complex.owner.email,
          "name":complex.owner.name,
          "lastname":complex.owner.lastname,
          "phone":complex.owner.phone,
          "password":complex.owner.password,
        },
        "price": complex.price,
        "players_subscription" : complex.playerSubscriptions,
        "currency" : complex.currency
    }


    ApiBase.post(`/sport_places`,data,callBack,ApiBase.noParse,errorCallBack)
  }

  static update(complex, callBack, errorCallBack){
    let data = {
      "status": complex.status,
        "name": complex.name,
        "address": complex.address,
        "description": complex.description,
        "lat": complex.lat,
        "lng": complex.lng,
        "invoice": complex.invoice,
        "city": complex.city,
        "country": complex.country,
        "state": complex.state,
        "price": complex.price,
        "players_subscription" : complex.playerSubscriptions,
        "currency" : complex.currency
    }

    ApiBase.put(`/sport_places/${complex.id}`,data,callBack,ApiBase.noParse,errorCallBack)
  }

  static changeStatus(complex, callBack, errorCallBack){
    let data = {
      "status": complex.status == "active" ? "inactive" : "active",
    }

    ApiBase.put(`/sport_places/${complex.id}`,data,callBack,ApiBase.noParse,errorCallBack)
  }

  static delete(complex, callBack, errorCallBack){
    ApiBase.delete(`/sport_places/${complex.id}`,callBack,ApiBase.noParse,errorCallBack)
  }

}

export default ApiComplexes



// WEBPACK FOOTER //
// ./src/api/apiComplexes.js